var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9063 4.03125L6.1875 12.75L3.09375 9.65625C2.71875 9.28125 2.15625 9.28125 1.78125 9.65625C1.40625 10.0313 1.40625 10.5937 1.78125 10.9687L5.53125 14.7187C5.71875 14.9062 5.90625 15 6.1875 15C6.46875 15 6.65625 14.9062 6.84375 14.7187L16.2187 5.34375C16.5937 4.96875 16.5937 4.40625 16.2187 4.03125C15.8437 3.65625 15.2813 3.65625 14.9063 4.03125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckThin);
export default __webpack_public_path__ + "static/media/icon-check-thin.d1821d641df54928728b1f0288253ee8.svg";
export { ForwardRef as ReactComponent };